module.exports = __webpack_public_path__ + "media/vid-group.704beb6d.mp4";